import { snakeCaseKeys } from "../utils";
import type { SerialisedEvent, TrackingProps } from "./types";

export const getContexts = (
  config: TrackingProps,
): Record<string, SerialisedEvent> => {
  // Create an object that only contains Context keys
  // and snake_case the keys
  const contextEntries = Object.entries(config || {})
    .filter(([key]) => key.includes("Context") && key !== "includeGAContext")
    .reduce((acc, [key, value]) => {
      if (typeof value === "object") {
        return { ...acc, [key]: snakeCaseKeys({ ...value }) };
      }
      return {
        ...acc,
        [key]: snakeCaseKeys({ data: { service_channel_identifier: value } }),
      };
    }, {});

  return contextEntries as Record<string, SerialisedEvent>;
};

export const updateIdentityContext = (
  contexts: Record<string, SerialisedEvent>,
  uid: unknown,
): Record<string, SerialisedEvent> => {
  const index = Object.keys(contexts).findIndex(ctx =>
    contexts[ctx].schema?.includes("identity_context"),
  );
  if (index > -1) {
    const key = Object.keys(contexts)[index];
    return {
      ...contexts,
      [key]: {
        ...contexts[key],
        data: {
          ...contexts[key].data,
          domain_userid: uid,
        },
      },
    };
  }
  return contexts;
};

export const makeContexts = (
  keys: string[],
  config: Record<string, SerialisedEvent>,
): SerialisedEvent[] => (keys || []).map(key => config[key]);
